// extracted by mini-css-extract-plugin
module.exports = {"row":"ProductTableListItem_row__9k2Pi"};